import styled from "styled-components";

export const Container = styled.div`
  color: var(--white);
  max-width: 32rem;

  .form {
    .login__btn {
      margin: 2.4rem 0;
    }
    .login__status {
      margin: 4rem 0;
      text-align: center;
      &--link {
        color: #fff;
        font-weight: 900;
      }
    }

    .login__terms {
    }
  }

  @media (min-width: 1024px) {
    .form {
      .login__status {
        margin: 2rem 0;
      }
    }
  }
`;
